// extracted by mini-css-extract-plugin
export var inputContainer = "_sb-0";